import { IJBPPartnerGroupsExtData } from 'legacy/lut/classes/models/partner360/IPartnerGroup'
import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'

export const mapToIWWPartners = (data: IJBPPartnerGroupsExtData): IWWPartners => {
  return {
    PartnerID: data.PartnerId,
    CommunicationName: data.CompanyName,
    GeoMarket: data.GeoMarket,
    LocationID: data.LocationId,
    HierarchyType: data.HierarchyType,
    TopPartnerID: data.PartnerId,
    ParentPartnerID: data.PartnerId,
    Country: data.Country,
    Plan360Completeness: data.Plan360Completeness,
    IsAcknowledged: data.IsAcknowledged,
  }
}
